<template>
    <div class="tradepoint-card-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Discount Card in partnership with TradePoint
                </div>
                <div class="logo">
                    <img src="/images/trade-point-logo-small.png">
                </div>
            </div>
            <div class="box-1">
                <h1>Exclusive 10% Discount</h1>
                <p>
                    TradePoint supply products and services for every project, all under one roof at convenient locations nationwide.
                </p>
                <div>
                    <a href="https://forms.fensa.org.uk/tradepoint-registration/" target="_blank" class="btn-primary _lg" @click="partnerLinkClicked()">
                        Apply Now
                    </a>
                </div>
            </div>
            <div class="overlapping-image">
                <img src="/images/offers-and-promotions-tradepoint-header.png">
            </div>
            <div class="box-2">
                <p>
                    Get an exclusive 10% discount when purchasing materials in store or online using a TradePoint card with no minimum spend.
                </p>
                <div v-if="!logged_in_user.isStaff">
                    <a class="btn-primary-outline _lg" @click.prevent="enquiry_box_open = true">
                        Make Enquiry
                    </a>
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">TradePoint Card Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like some more information on signing up for a TradePoint card',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 19,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Tradepoint enquiry',
                'value': 'Tradepoint enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Tradepoint`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Tradepoint card partner link clicked',
          'value': 'Tradepoint card partner link clicked',
        });
      },
    },
};
</script>
